/**
 * Overlay component for mobile navigation
 */

const Overlay = () => {
  let overlayElement = null;

  const create = () => {
    if (overlayElement) return overlayElement;

    overlayElement = document.createElement("div");
    overlayElement.className = "mobile-nav-overlay";
    overlayElement.setAttribute("aria-hidden", "true");
    document.body.appendChild(overlayElement);

    return overlayElement;
  };

  const show = () => {
    const overlay = create();
    document.body.classList.add("mobile-nav-open");

    // Force reflow before adding show class for animation
    overlay.offsetHeight;
    overlay.classList.add("show");
  };

  const hide = () => {
    if (!overlayElement) return;

    document.body.classList.remove("mobile-nav-open");
    overlayElement.classList.remove("show");

    // Remove immediately from DOM
    if (overlayElement && overlayElement.parentNode) {
      overlayElement.parentNode.removeChild(overlayElement);
      overlayElement = null;
    }
  };

  const onClick = (callback) => {
    if (overlayElement) {
      overlayElement.addEventListener("click", callback);
    }
  };

  return { show, hide, onClick };
};

export default Overlay;
